<template>
  <!--新增对话框-->
  <el-dialog
    title="编辑商品参数"
    :visible.sync="dialogVisible"
    width="1024px"
    :close-on-click-modal="false"
    append-to-body
    :before-close="handleClose"
  >
    <el-form
      :model="editForm"
      ref="editForm"
      label-width="100px"
      class="demo-editForm"
    >
      <div
        class="relContent"
        v-for="(item, index) in editForm.list"
        :key="index"
      >
        <el-form-item
          label="参数"
          :prop="'list.' + index + '.parameterId'"
          :rules="{
            validator: (rule, value, callback) => {
              bankIdValidator(rule, value, callback, item);
            },
            trigger: 'change',
          }"
          style="display: inline-block"
        >
          <el-select v-model="item.parameterId" clearable placeholder="请选择">
            <el-option
              v-for="item1 in parametrList"
              :key="item1.parameterId"
              :label="item1.parameterName"
              :value="item1.parameterId"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          label="参数值"
          :prop="'list.' + index + '.parameterValue'"
          :rules="{
            validator: (rule, value, callback) => {
              dataValueValidator(rule, value, callback, item);
            },
            trigger: 'change',
          }"
          style="display: inline-block; margin-right: 5px"
        >
          <el-input v-model="item.parameterValue" autocomplete="off"></el-input>
        </el-form-item>

        <div class="tabs-title">
          <div class="add-icon">
            <el-button
              v-if="index === editForm.list.length - 1"
              type="primary"
              @click.prevent="addCartonsRuleList(item)"
              style="margin-left: 5px"
              >新增参数</el-button
            >
            <el-button
              @click.prevent="removeCartonsRuleList(item)"
              v-if="editForm.list.length > 1"
              style="margin-left: 5px"
              >删除</el-button
            >
          </div>
        </div>
      </div>
      <el-form-item>
        <el-button type="primary" @click="submitForm('editForm')"
          >保存</el-button
        >
        <el-button @click="resetForm('editForm')">重置</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
export default {
  name: "BoxRule",
  data() {
    return {
      dialogVisible: false,
      parametrList: [],
      cartonsGoodsId: 0,
      storeGoodsId: 0,
      editForm: {
        list: [],
      },
    };
  },
  methods: {
    getSingleStoreRoleInfo(id) {
      this.$axios
        .post("/admin/singleStoreGoods/getSingleStoreRoleInfo", {
          cartonsGoodsId: id,
        })
        .then((res) => {
          if (
            res.data != undefined &&
            res.data != null &&
            res.data.length > 0
          ) {
            console.log("dse", res.data);
            this.editForm.list = res.data;
          } else {
            console.log(66666);
            var item = {
              parameterValue: "",
              parameterId: "",
              cartonsGoodsId: this.cartonsGoodsId,
              storeGoodsId: this.storeGoodsId,
              requiredstartSection: false,
              requiredendSection: false,
            };
            var list = [];
            list.push(item);
            this.editForm.list = list;
          }
        });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        console.log("valid", valid);
        if (valid) {
          this.$axios
            .post(
              "/admin/singleStoreGoods/addSingleStoreRoleInfo",
              this.editForm.list
            )
            .then((res) => {
              this.$message({
                showClose: true,
                message: "恭喜你，操作成功",
                type: "success",
                onClose: () => {
                  this.$emit("refreshDataList");
                },
              });
              this.dialogVisible = false;
              this.resetForm(formName);
            });
        }
      });
    },
    change(e) {
      this.$forceUpdate();
    },
    bankIdValidator(rule, value, callback, domain) {
      domain.requiredendSection = domain.parameterId ? true : false;
      if (domain.requiredstartSection) {
        if (!domain.parameterId) {
          callback(new Error("请选择参数"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    },
    dataValueValidator(rule, value, callback, domain) {
      domain.requiredstartSection = domain.parameterValue ? true : false;
      if (domain.requiredendSection) {
        if (!domain.parameterValue) {
          callback(new Error("请输入参数值"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.dialogVisible = false;
      this.storeGoodsId = "";
      this.cartonsGoodsId = "";
      this.editForm = {
        list: [],
      };
    },
    handleClose() {
      this.resetForm("editForm");
    },
    getParameterList() {
      this.$axios.post("/admin/parameter/getAllParameter").then((res) => {
        this.parametrList = res.data;
      });
    },
    init(cartonsGoodsId, storeGoodsId) {
      this.dialogVisible = true;
      this.cartonsGoodsId = cartonsGoodsId;
      this.storeGoodsId = storeGoodsId;
      this.getParameterList();
      this.getSingleStoreRoleInfo(cartonsGoodsId);
      console.log(this.editForm.list);
    },
    removeCartonsRuleList(item) {
      if (this.editForm.list.length === 1) {
        this.editForm.list[0].parameterValue = "";
        this.editForm.list[0].parameterId = "";
        this.editForm.list[0].cartonsGoodsId = this.cartonsGoodsId;
        this.editForm.list[0].storeGoodsId = this.storeGoodsId;
        this.editForm.list[0].requiredstartSection = false;
        this.editForm.list[0].requiredendSection = false;
      } else {
        var index = this.editForm.list.indexOf(item);
        if (index !== -1) {
          this.editForm.list.splice(index, 1);
        }
      }
      this.$forceUpdate();
    },
    addCartonsRuleList(item) {
      console.log("ssss", item);
      if (item.parameterId == "" || item.parameterValue === "") {
        this.$message({
          message: "该参数没有填完",
          type: "warning",
        });
        return;
      }
      var item = {
        parameterValue: "",
        parameterId: "",
        cartonsGoodsId: this.cartonsGoodsId,
        storeGoodsId: this.storeGoodsId,
        requiredstartSection: false,
        requiredendSection: false,
      };
      this.editForm.list.push(item);
      this.$forceUpdate();
    },
  },
};
</script>

<style scoped>
.el-form-item__content {
  width: 214px;
  display: inline-block;
}
.tabs-title {
  display: inline-block;
}
.light .tabs-title div span:last-child,
.drak .tabs-title div span:last-child {
  margin-left: 0;
}
.el-dialog__body {
  max-height: 600px;
  overflow-y: auto;
}
</style>
